import { checkout } from "cldffecop-tagging-utils";

export const formatThousandsSeparator = (number: number) =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

/* istanbul ignore next */
export const getValues = (array: [], group: string, subGroup: string) => {
  const newArray = array.filter(
    (value: any) => value.group === group && value.subGroup === subGroup
  );
  if (newArray.length > 0) {
    return newArray
      .map((income: any) => income.value)
      .reduce(
        (lastValue: string, currentValue: string) =>
          parseInt(lastValue) + parseInt(currentValue)
      );
  } else {
    return 0;
  }
};

export const getInitialsUsername = (name: string) =>
  name
    .split(/\s/)
    .reduce((response, word) => (response += word.slice(0, 1)), "");

export const getUsername = (array: [], name: string) => {
  const filter = array.filter((a: any) => a.name.toString() === name) as any;
  if (filter.length > 0) {
    return filter[0].value;
  }
  return "";
};

/* istanbul ignore next */
export const tagCoach = (
  stepNumber: string,
  option: string,
  dimension3: string,
  quantity: string
) => {
  checkout({
    step: stepNumber,
    stepName: "coach-financiero",
    extraDimension: {
      price: "",
      quantity: quantity,
      dimension3,
      option: option,
    },
  });
};
